import React from 'react'
import { SvgIcon } from '@material-ui/core'

function CopyIcon(props) {
  return (
    <SvgIcon {...props}>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M11.3214 5.75C10.4733 5.75 9.78571 6.43757 9.78571 7.28572V13C9.78571 13.8482 10.4733 14.5357 11.3214 14.5357H17.0357C17.8839 14.5357 18.5715 13.8482 18.5715 13V7.28572C18.5715 6.43757 17.8839 5.75 17.0357 5.75H11.3214ZM8.28571 7.28572C8.28571 5.60914 9.64484 4.25 11.3214 4.25H17.0357C18.7123 4.25 20.0715 5.60914 20.0715 7.28572V13C20.0715 14.6766 18.7123 16.0357 17.0357 16.0357H11.3214C9.64484 16.0357 8.28571 14.6766 8.28571 13V7.28572Z'
        fill='#444444'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.78571 8H7.03572C5.35914 8 4 9.35914 4 11.0357V16.75C4 18.4266 5.35914 19.7857 7.03572 19.7857H12.75C14.4266 19.7857 15.7857 18.4266 15.7857 16.75V14.5357H14.2857V16.75C14.2857 17.5982 13.5982 18.2857 12.75 18.2857H7.03572C6.18757 18.2857 5.5 17.5982 5.5 16.75V11.0357C5.5 10.1876 6.18757 9.5 7.03572 9.5H9.78571V8Z'
        fill='#444444'
      />
      <path
        d='M15.6538 10.2725C16.1197 10.2725 16.4975 10.6388 16.4975 11.0906L16.4971 11.4988C16.5549 12.5005 15.7593 13 14.2838 13C12.8131 13 12 12.507 12 11.5131V11.0906C12 10.6388 12.3777 10.2725 12.8437 10.2725H15.6538ZM14.2499 7C15.0267 7 15.6564 7.61057 15.6564 8.36376C15.6564 9.11694 15.0267 9.72751 14.2499 9.72751C13.4732 9.72751 12.8435 9.11694 12.8435 8.36376C12.8435 7.61057 13.4732 7 14.2499 7Z'
        fill='#444444'
      />
    </SvgIcon>
  )
}

export default CopyIcon
